import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { LicenseManager } from 'ag-grid-enterprise';

LicenseManager.setLicenseKey((window as any).__env?.agGridLicenseKey);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
